import { useInfiniteQuery } from "@tanstack/react-query";
import {
  PatientTableDto,
  PatientTableFilters,
  RxTableDto,
  RxTableFilters,
} from "../../../api-client";
import { useApi } from "../../../api/ApiProvider";
import { patientKeys } from "../../../stores/Patients";
import moment from "moment";
import { rxKeys } from "../../../stores/Rx";
import { useEffect } from "react";
import { useDebouncedValue } from "../../../utils/useDebounce";

interface UseRxOptions {
  filters?: RxTableFilters;
  enabled?: boolean;
}

export const useInfiniteRxsTable = ({ filters = {}, enabled = true }: UseRxOptions = {}) => {
  const { rx: rxApi } = useApi();
  const limit = filters.limit ?? 50;
  const debouncedQuery = useDebouncedValue(filters.lastName || undefined);
  // console.debug("filters.lastName and debouncedQuery",filters.lastName, debouncedQuery);
  const filtersForAPI = { ...filters, lastName: debouncedQuery };

  // const filtersWithoutSearch = { ...filters, lastName: undefined };
  const query= useInfiniteQuery<RxTableDto[], Error>({
    queryKey: rxKeys.allRxsTable.filtered(filtersForAPI),
    queryFn: async ({ pageParam = 1 }) =>
      rxApi.getFilteredAllRxs({ ...filtersForAPI, page: pageParam as number, limit }),
    getNextPageParam: (lastPage, allPages) =>
      lastPage.length >= limit ? allPages.length + 1 : undefined,
    staleTime: moment.duration(10, "minutes").asMilliseconds(),
    initialPageParam: 1,
    enabled,
    meta: { errorMessage: "Rezeptliste konnte nicht geladen werden" },
  });
   // Refetch when debounced query changes
    // useEffect(() => {
    //   query.refetch({ cancelRefetch: true });
    // }, [debouncedQuery]); // refetch is stable
     useEffect(() => {
      // console.debug("debouncedQuery changed, refetching Rxs table", debouncedQuery, enabled, filters);
      if (enabled) {
        query.refetch({ cancelRefetch: true });
      }
    }, [debouncedQuery, enabled]);
  
    return query;
};
